const styles = {
    goToButton: {
        marginRight: 20
    },
    goToContainer:{
        float: 'right', height: 50
    }
  };

  export default styles;



// WEBPACK FOOTER //
// ./src/components/common/styles/PageBaseStyles.js